import HeroCanvas from './HeroCanvas';
import styles from '../styles/Hero.module.css';

const NAME = 'Yaseen';

const HERO_STATS = [
  { value: '3+', label: 'Years Experience', pos: 'chip1' },
  { value: '100+', label: 'Websites Delivered', pos: 'chip2' },
  { value: '30+', label: 'Sites Managed', pos: 'chip3' },
];

export default function Hero() {
  return (
    <section id="top" className={styles.hero}>
      <HeroCanvas />
      <div className={styles.vignette} />

      <div className={styles.inner}>
        <div className={`${styles.kicker} hero-kicker`}>
          <span className={styles.kickerLine} />
          <span className={styles.kickerText}>Karachi, Pakistan</span>
        </div>

        <h1 className={styles.name} aria-label={NAME}>
          {NAME.split('').map((char, i) => (
            <span className={styles.charWrap} key={`${char}-${i}`}>
              <span
                className={`${styles.char} ${i === NAME.length - 1 ? styles.charAccent : ''} hero-char`}
              >
                {char}
              </span>
            </span>
          ))}
        </h1>

        <p className={styles.subtitle}>
          <span data-typer data-text="WordPress Developer | MERN Stack | SaaS Builder">
            WordPress Developer | MERN Stack | SaaS Builder
          </span>
          <span className={styles.caret} />
        </p>

        <div className={`${styles.ctaRow} hero-cta`}>
          <a
            href="#projects"
            className={styles.ctaPrimary}
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('projects')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            View Work <span style={{ fontSize: 16 }}>→</span>
          </a>
          <a
            href="#contact"
            className={styles.ctaSecondary}
            onClick={(e) => {
              e.preventDefault();
              document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Contact Me
          </a>
          <a href="/Muhammad-Yaseen-CV.pdf" download className={styles.ctaGhost}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M12 4v11m0 0-4-4m4 4 4-4M5 19h14" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Download CV
          </a>
        </div>
      </div>

      {HERO_STATS.map((stat) => (
        <div key={stat.label} className={`${styles.statChip} ${styles[stat.pos]} hero-chip`}>
          <span className={styles.statChipValue}>{stat.value}</span>
          <span className={styles.statChipLabel}>{stat.label}</span>
        </div>
      ))}

      <div className={styles.scrollCue}>
        <span>Scroll</span>
        <i />
      </div>
    </section>
  );
}
